import React from 'react';

export interface IconBaseProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  viewBox: string;
}

interface SvgProps extends IconBaseProps {
  children: React.ReactNode;
}

export default function IconBase({ size = 18, viewBox, children, ...others }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill="currentColor"
      width={size}
      height={size}
      {...others}
    >
      {children}
    </svg>
  );
}